export { default } from './Skeleton';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/Skeleton/index.js
// module id = 887
// module chunks = 2